/**
 * src/components/InstagramSection.jsx
 * No live Instagram API integration — that needs a Meta Business/Graph API
 * setup. This is a manually curated strip mixing your real store reels
 * (autoplay, muted, looping — same files the old Lookbook section used)
 * with photos. Edit POSTS below to add/remove/reorder items.
 */
import { useRef } from "react";

const INSTAGRAM_URL = "https://www.instagram.com/ritufashionstore.in/";

// type: "video" plays muted/looping/autoplay, matching a reel.
// type: "image" is a plain photo. Add or swap file paths as you like —
// anything you drop into /public can be referenced here the same way.
const POSTS = [
  { type: "video", src: "/store-reel-1.mp4" },
  { type: "image", src: "/girl-model.jpeg" },
  { type: "video", src: "/store-reel-2.mp4" },
  { type: "video", src: "/store-reel-3.mp4" },
  { type: "video", src: "/store-reel-4.mp4" },
  { type: "video", src: "/store-reel-5.mp4" },
];

export function InstagramSection() {
  const scrollerRef = useRef(null);

  function scrollByAmount(dir) {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
  }

  return (
    <section className="section">
      <h2 className="section-title text-center">Catch Us on the 'Gram</h2>

      <div className="insta-gallery mt-8">
        <button className="insta-arrow insta-arrow-left" aria-label="Previous" onClick={() => scrollByAmount(-1)}>
          ‹
        </button>

        <div className="insta-scroller" ref={scrollerRef}>
          {POSTS.map((post, i) => (
            <a key={i} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="insta-item">
              {post.type === "video" ? (
                <video
                  src={post.src}
                  muted
                  loop
                  autoPlay
                  playsInline
                  preload="metadata"
                  onError={(e) => { e.target.style.display = "none"; }}
                />
              ) : (
                <img src={post.src} alt="Ritu Fashion Store on Instagram" loading="lazy" />
              )}
            </a>
          ))}
        </div>

        <button className="insta-arrow insta-arrow-right" aria-label="Next" onClick={() => scrollByAmount(1)}>
          ›
        </button>
      </div>

      <div className="container">
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="insta-handle">
          @ritufashionstore.in
        </a>
      </div>
    </section>
  );
}